import remindImgInWechat from '../../assets/images/liulan.png'
const Mask = ({hideMask}:any) => {
    return  <div className="mask">
        <img src={remindImgInWechat} alt="mask img" />
        <div className="knowBtn" onClick={hideMask}>我知道了</div>
    </div>
}
export default Mask
